import React from 'react';
import { useLocation } from 'react-router-dom';

function SuccessPage() {
  const location = useLocation();
  const message = location.state?.message || "✅ PDF generated successfully. Please check your downloads folder. If the pdf did not automatically downlaod, please use the 'Download PDF' link below.";

  const pdfUrl = location.state?.pdfUrl;

  return (
    <>
      <h1 className="center-text">
        <span role="img" aria-label="party popper">🎉</span> Submission Complete
      </h1>

      <p className="center-text">{message}</p>

      <a
        href={pdfUrl}
        download="Kasba Fund I, LP Subscription Agreement.pdf"
        className="center-text"
        onClick={(e) => {
          // Safari/iOS fallback
          if (!pdfUrl) {
            e.preventDefault();
          }
        }}
      >
        Download PDF
      </a>

      <br>
      </br>


      <a href="/" className="center-text">Return Home</a>
    </>
  );
}

export default SuccessPage;
